<template>
  <div>
    <shop-header :store-id="storeid" />
    <div class="container">
      <div class="row my-4 justify-content-center">
        <div class="col-md-9 bg-white py-4">
          <form
            class="pt-2 pb-4 d-flex flex-wrap justify-content-center"
            @submit.prevent="resetPassword"
          >
            <h3
              class="form-group w-75 mb-4"
              v-if="IsNewUser === 'true'"
              style="margin-botton: 20px"
            >
              {{ $t("message.registerNewAccount") }}
            </h3>
            <h3 class="form-group w-75 mb-4" v-else style="margin-botton: 20px">
              {{ $t("message.forgotPassword") }}
            </h3>
            <span
              class="form-group w-75"
              v-if="recoveryLinkExpired"
              style="margin-botton: 20px"
              >{{ $t("message.passwordRecoveryLinkIsNoLongerValid") }}.</span
            >
            <div class="form-group w-75" v-if="UserDoc">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="First Name">{{ $t("message.firstName") }}</label>
                  <br />
                  <label
                    id="FirstName"
                    class="text-dark"
                    name="First Name"
                    v-if="UserDoc.FirstName"
                  >
                    <strong
                      >{{ UserDoc.FirstName.substring(0, 1).toUpperCase()
                      }}{{ UserDoc.FirstName.substring(1) }}</strong
                    >
                  </label>
                </div>
                <div class="form-group col-md-6">
                  <label for="Last Name">{{ $t("message.lastName") }}</label>
                  <br />
                  <label
                    id="FirstName"
                    class="text-dark"
                    name="First Name"
                    v-if="UserDoc.LastName"
                  >
                    <strong
                      >{{ UserDoc.LastName.substring(0, 1).toUpperCase()
                      }}{{ UserDoc.LastName.substring(1) }}</strong
                    >
                  </label>
                </div>
              </div>
            </div>
            <div class="form-group w-75" v-if="UserDoc">
              <label for="email">{{ $t("message.email") }}</label>
              <br />
              <label
                id="email"
                class="text-dark"
                v-if="UserDoc.Email"
                name="email"
              >
                <strong
                  >{{ UserDoc.Email.substring(0, 1).toUpperCase()
                  }}{{ UserDoc.Email.substring(1) }}</strong
                >
              </label>
            </div>
            <div
              class="form-group w-75"
              v-if="!registrationResponse && UserDoc"
            >
              <label for="password">{{ $t("message.password") }}</label>
              <input
                id="passwordId"
                v-model="UserDoc.Password"
                type="password"
                name="password"
                v-validate="'required|min:6|max:20'"
                class="form-control"
                ref="password"
              />

              <div class="invalid-feedback">
                {{ OOErrors.first("password") | inputNameLocale("password") }}
              </div>
            </div>
            <div
              class="form-group w-75"
              v-if="!registrationResponse && UserDoc"
            >
              <label for="Confirm Password">{{
                $t("message.confirmPassword")
              }}</label>
              <input
                id="ConfirmPasswordId"
                v-model="UserDoc.ConfirmPassword"
                type="password"
                name="confirmPassword"
                v-validate="'required|confirmed:password|min:6|max:20'"
                class="form-control"
              />

              <div class="invalid-feedback">
                {{
                  OOErrors.first("confirmPassword")
                    | inputNameLocale("confirmPassword")
                }}
              </div>
            </div>
            <div
              class="w-75 mt-3"
              v-if="
                UserDoc &&
                (!registrationResponse ||
                  (registrationResponse && registrationResponse.status != 200))
              "
            >
              <button
                :style="desktopStyles.btn"
                class="btn btn-primary btn-sign-in btn-lg w-100 shadow d-flex justify-content-center align-items-center"
                @click="resetPassword()"
              >
                {{ IsNewUser === "true" ? "Register" : "Reset" }}
                <span v-show="loading">
                  <i class="spin ml-4" />
                </span>
              </button>
            </div>
            <div
              v-if="
                registrationResponse &&
                registrationResponse.status &&
                registrationResponse.status == 200
              "
              class="w-75 mt-4"
            >
              <div class="alert alert-success" role="alert">
                <strong>{{ registrationResponse.msg }}</strong>
              </div>
            </div>
            <div
              v-if="
                registrationResponse &&
                registrationResponse.status &&
                registrationResponse.status == 500
              "
              class="w-75 mt-4"
            >
              <div class="alert alert-danger" role="alert">
                <strong>{{ registrationResponse.msg }}</strong>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <shopfooter />
  </div>
</template>

<script>
import shopfooter from "./../../shared/shopfooter";
import ShopHeader from "./../partials/shopheader";
import { mapGetters } from "vuex";

import shared from "../../../../src/sharedscripts/user/register.js";
export default {
  components: {
    ShopHeader,
    shopfooter,
  },
  props: {
    storeid: {
      type: String,
      default: "",
    },

    base64User: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      recoveryLinkExpired: false,
      email: "",
      password: "",
      loading: false,
      UserDoc: null,
      IsNewUser: "false",
      registrationResponse: null,
    };
  },
  computed: {
    ...mapGetters(["desktopStyles"]),
  },
  async mounted() {
    this.loadRecoveryPasswordForm(this.base64User);
  },
  methods: {
    ...shared.methods,
  },
};
</script>
